import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';

/* imported API-calls */
import { clientDataService } from './../../Services/clientDataService';

/* imported front-end */
import PasswordDialog from '../Password/PasswordDialog';

export default function IndexPage() {
    const classes = useStyles();
    const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);

    console.log('row row row', rows)
    const handleOpen = () => {
        setOpenPasswordDialog(true);

    }
    const handleClose = () => {
        setOpenPasswordDialog(false);
    };
    useEffect(() => {
        if (reload === true){
            setReload(false);
        }
        let mounted = true
        clientDataService.getClients().then(o => {
            if (mounted) {
                if(JSON.stringify(rows) !== JSON.stringify(o)){
                    setRows(o);
                }
            }
        }).catch((error) => {toast.error(error, {position: toast.POSITION.TOP_CENTER})})
    },[rows, reload]);

    return (
            <React.Fragment>
                <div className={classes.container}>
                      <div className={classes.buttonWell}> 
                    <NavLink className={classes.navButton} to="/client">
                        <Button className={classes.styledButton} color="primary" fullWidth variant="contained" >Clients</Button>
                    </NavLink>
                    <NavLink className={classes.navButton} to="/api">
                        <Button className={classes.styledButton} color="primary" fullWidth variant="contained" >API</Button>
                    </NavLink>
                    <span className={classes.navButton}>
                        <Button className={classes.styledButton} onClick={handleOpen} color="primary" fullWidth variant="contained" >Generate client password</Button>
                    </span>
                    <PasswordDialog open={openPasswordDialog} clients={rows} handleClose={handleClose} ></PasswordDialog>

                    
                </div>
                </div>
              
            </React.Fragment>
    );
}

const useStyles = makeStyles({
    container: {
        height: '100%',
        position: 'relative',
        textAlign: 'center',
        verticalAlign: 'middle',
        display: 'flex',
    },
    buttonWell: {
        marginTop: 'auto',
        marginBottom: 'auto',
        width: '100%',
    },
    navButton: {
        justifyContent: 'center',
        textAlign: 'center',
        textDecoration: 'none',
        height: '80px',
        width: '50%',
        alignContent: 'center',
    },
    styledButton: {
        alignContent: 'center',
        marginBottom: '25px',
        width: '51%',
        height: '80px',
        fontSize: '20px !important'
    }
  
});